<template>
  <div>
    <el-card
      class="card-container"
      shadow="never"
    >
      <CardHeader
        slot="header"
        title="Danh sách thẻ Tags"
        :total="total"
        :size="'small'"
        :disabled="loading"
        :permission="permission"
        @create="handleCreate"
        @refresh="handleRefresh"
      />
      <div>
        <CardFilter />
        <CardList
          :data="data"
          :loading="loading"
          :permission="permission"
          @update="handleUpdate"
          @delete="handleDelete"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </el-row>
      </div>
      <DataFormPopup
        v-if="formVisible"
        :item="selectedItem"
        :visible="formVisible"
        @close="formVisible = false"
        @reload="listData"
      />
    </el-card>
  </div>
</template>

<script>
import CardFilter from "./components/CardFilter.vue";
import CardHeader from "./components/CardHeader.vue";
import CardList from "./components/CardList.vue";
import DataFormPopup from "./popups/DataForm.vue";

import { notification } from "@/utils/common";
import { tagPer } from "@/utils/permission";

import tagServices from "@/services/tag";
import organizationServices from "@/services/organization";
import constants from "@/config/constants";

export default {
  name: "Tags",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    DataFormPopup,
  },
  data() {
    return {
      loading: false,
      searchText: "",
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 0,
      data: [],
      selectedItem: null,
      formVisible: false,
      permission: tagPer(),
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
        filters: {
          organization_id: this.organizationId,
        }
      };
      if (this.searchText) {
        _params.filters[`extra.name`] = { $regex: this.searchText }
      }
      return _params;
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      this.loading = true;
      tagServices
        .list(this.params)
        .then((response) => {
          this.data = response.items.map((item, index) => ({
            ...item,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        tagServices
          .remove(item)
          .then(() => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            this.listData();
            notification(this, "success", "delete", "thẻ tag");
          })
          .catch(() => {
            notification(this, "error", "delete", "thẻ tag");
          });
      });
    },
    handleSearch() {
      this.page = 1;
      this.listData();
    },
    handleRefresh() {
      this.selectedItem = null;
      this.page = 1;
      this.searchText = "";
      this.listData();
    },
    handleChangePage(page) {
      this.page = page;
      this.listData();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listData();
    },
  },
};
</script>

<style lang="scss"></style>
